export const PRODUCTS_URL = '/api/v3/products/';
export const RECOMMENDATIONS_URL = `/api/v3/product-recommendations/`;
export const ALL_RECIPES = ['chicken', 'beef', 'lamb', 'turkey'];
export const ALL_PRODUCT_TYPES = ['fresh', 'dry', 'mixed'];
export const PRODUCT_TYPE_FRESH = 'FR';
export const PRODUCT_TYPE_DRY = 'DY';
export const PRODUCT_TYPE_MIXED = 'MX';
export const productTypeReference = {
  [PRODUCT_TYPE_FRESH]: 'fresh',
  [PRODUCT_TYPE_MIXED]: 'mixed',
  [PRODUCT_TYPE_DRY]: 'dry',
};
export const DEFAULT_FRESH = {
  starterBoxes: [],
  products: [],
  availableRecipes: {
    fresh: [],
    dry: [],
  },
};
export const DEFAULT_DRY = {
  starterBoxes: [],
  products: [],
  availableRecipes: {
    fresh: [],
    dry: [],
  },
};
export const DEFAULT_MIXED = {
  starterBoxes: [],
  products: [],
  availableRecipes: {
    fresh: [],
    dry: [],
  },
};
